<template>
    <div class="teaser-button">
        <a :href="url">
            <div :style="{backgroundImage: `url(${image})`}"></div>
        </a>
    </div>
</template>

<script>
    export default {
        name: "TeaserButton",
        props: {
            url: {
                type: String,
                required: true
            },
            image: {
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .teaser-button {
        display: flex;
        flex: 1;
        a {
            display: flex;
            flex: 1;
            div {
                flex: 1;
                position: relative;
                z-index: -1;
                max-width: 100%;
                height: auto;
                background-position: center center;
                background-size: cover;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/TeaserButton.vue